export const secondsToMiliseconds = 1000;